module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Crystallize","short_name":"Crystallize","start_url":"/","icon":"src/images/shop-logo.svg","background_color":"#f3f4f6","theme_color":"#B7E2E4","display":"minimal-ui","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"ae7c9128ca2fb7cc63f6f7fc1fc4ce17"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
